import { Component, OnInit } from '@angular/core';

import { AuthService } from 'app/shared/services/auth.service';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
	standalone: true,
})
export class LogoutComponent implements OnInit {
	constructor(private authService: AuthService) {}

	ngOnInit(): void {
		this.authService.logout();
	}
}
